var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("user.dashboard.interview.title"))+" ")]),_c('v-card-text',[_c('Markdown',{attrs:{"value":_vm.$t('user.dashboard.interview.description')}})],1),_c('v-card-actions',[_c('v-btn',{attrs:{"to":{
        name: 'userAuditPeriodInterview',
        params: { id: _vm.auditPeriod.id },
      },"color":"primary"}},[_vm._v(" "+_vm._s(_vm.$t("user.dashboard.interview.cta"))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }